var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FileUpload',{attrs:{"mode":"basic","name":"demo[]","chooseLabel":"ייבוא","uploadLabel":"שמור","multiple":true,"accept":".csv","maxFileSize":1000000},on:{"before-send":_vm.beforeUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }